import { IController } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class EndorsementsCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public currentCohortFilterIncludingSuperSeniors;
  public currentCohortFilter;
  public currentCohortContainsSuperSeniors;
  public activeStudentsInCohortIds;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.currentCohortFilterIncludingSuperSeniors = this.WizardUtils.getCurrentCohortFilter();
    this.currentCohortFilter = _.last(this.currentCohortFilterIncludingSuperSeniors);
    this.currentCohortContainsSuperSeniors = Cohort[this.currentCohortFilter].studentYear === 4;
    this.activeStudentsInCohortIds = this.getActiveStudentsInCohortIds();
  }

  private getActiveStudentsInCohortIds = () => {
    const activeStudentsInCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: this.currentCohortFilterIncludingSuperSeniors,
    });
    const activeStudentsInCohortIds = _.map(activeStudentsInCohort, 'studentId');
    return activeStudentsInCohortIds;
  };
}
